// import glasses prototype object
import { GlassesProduct } from '@facecake/fmt-react-tryon/';

// load array of glasses products
const glasses = [
  { 
    brandName: 'RayBan',
    productName: 'Wayfarer Classic',
    price: '$153.00',
    productPdpUrl: 'https://www.ray-ban.com/usa/sunglasses/RB2140%20UNISEX%20062-original%20wayfarer%20classic-black/805289126577',
    productThumb: {
      unselected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_wayfarer.png',
      selected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_wayfarer_over.png',
    },
    glassesProduct: new GlassesProduct({
      productId: 1,
      productViews: [
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanWayfarer/RayBanWayfarerBlack_5.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanWayfarer/RayBanWayfarerBlack_6.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanWayfarer/RayBanWayfarerBlack_7.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanWayfarer/RayBanWayfarerBlack_8.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanWayfarer/RayBanWayfarerBlack_0.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanWayfarer/RayBanWayfarerBlack_1.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanWayfarer/RayBanWayfarerBlack_2.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanWayfarer/RayBanWayfarerBlack_3.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanWayfarer/RayBanWayfarerBlack_4.png',
      ],
    }),
  }, { 
    brandName: 'RayBan',
    productName: 'Caravan',
    price: '$153.00',
    productPdpUrl: 'https://www.ray-ban.com/usa/sunglasses/RB3136%20UNISEX%20004-caravan-gold/805289003465',
    productThumb: {
      unselected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_caravan.png',
      selected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_caravan_over.png',
     },
    glassesProduct: new GlassesProduct({
      productId: 2,
      productViews: [
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanCaravan/RayBanCaravan_5.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanCaravan/RayBanCaravan_6.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanCaravan/RayBanCaravan_7.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanCaravan/RayBanCaravan_8.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanCaravan/RayBanCaravan_0.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanCaravan/RayBanCaravan_1.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanCaravan/RayBanCaravan_2.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanCaravan/RayBanCaravan_3.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/RayBanCaravan/RayBanCaravan_4.png',
      ],
    }),
  }, { 
    brandName: 'Tory Burch',
    productName: 'Cat Eye',
    price: '$126.00',
    productPdpUrl:'https://click.linksynergy.com/deeplink?id=6V70MFsWQOU&mid=13867&murl=https%3A%2F%2Fwww.bloomingdales.com%2Fshop%2Fproduct%2Ftory-burch-womens-cat-eye-sunglasses-55mm%3FID%3D2899491%26CategoryID%3D3621%23fn%3Dppp%3Dundefined%26sp%3DNULL%26rId%3DNULL%26spc%3D1004%26spp%3D5%26pn%3D1%7C11%7C5%7C1004%26rsid%3Dundefined%26smp%3DmatchNone',
    productThumb: {
      unselected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_toriBurch.png',
      selected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_toriBurch_over.png',
    },
    glassesProduct: new GlassesProduct({
      productId: 3,
      productViews: [
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/ToryBurchCatEye/ToryBurchCatEye_5.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/ToryBurchCatEye/ToryBurchCatEye_6.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/ToryBurchCatEye/ToryBurchCatEye_7.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/ToryBurchCatEye/ToryBurchCatEye_8.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/ToryBurchCatEye/ToryBurchCatEye_0.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/ToryBurchCatEye/ToryBurchCatEye_1.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/ToryBurchCatEye/ToryBurchCatEye_2.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/ToryBurchCatEye/ToryBurchCatEye_3.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/ToryBurchCatEye/ToryBurchCatEye_4.png',
      ],
    }),
  }, { 
    brandName: 'Gucci',
    productName: 'Standard',
    price: '$360.00',
    productPdpUrl: 'https://click.linksynergy.com/deeplink?id=6V70MFsWQOU&mid=3184&murl=https%3A%2F%2Fwww.macys.com%2Fshop%2Fproduct%2Fgucci-sunglasses-gg0010s%3FID%3D4593327%26CategoryID%3D58262%23fn%3DBRAND%3DGucci%26SIZE%3D%26sp%3D1%26spc%3D841%26ruleId%3D105%7CBOOST%2520ATTRIBUTE%26searchPass%3DmatchNone%26slotId%3D2',
    productThumb: {
      unselected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_gucci.png',
      selected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_gucci_over.png',
    },
    glassesProduct: new GlassesProduct({
      productId: 4,
      productViews: [
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Gucci_GG0010S/Gucci_GG0010S_5.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Gucci_GG0010S/Gucci_GG0010S_6.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Gucci_GG0010S/Gucci_GG0010S_7.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Gucci_GG0010S/Gucci_GG0010S_8.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Gucci_GG0010S/Gucci_GG0010S_0.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Gucci_GG0010S/Gucci_GG0010S_1.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Gucci_GG0010S/Gucci_GG0010S_2.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Gucci_GG0010S/Gucci_GG0010S_3.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Gucci_GG0010S/Gucci_GG0010S_4.png',
      ],
    }),
  }, { 
    brandName: 'JINS',
    productName: 'Optical',
    price: '$80.00',
    productPdpUrl: 'https://www.jins.com/us/mmf-14a-u456.html',
    productThumb: {
      unselected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_gucci.png',
      selected: 'https://demos.facecake.com/CES2019/images/products/glasses/thumb_glasses_gucci_over.png',
    },
    glassesProduct: new GlassesProduct({
      productId: 5,
      productViews: [
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Jins/Jins-MMF-14A-U456_0_5.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Jins/Jins-MMF-14A-U456_0_6.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Jins/Jins-MMF-14A-U456_0_7.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Jins/Jins-MMF-14A-U456_0_8.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Jins/Jins-MMF-14A-U456_0_0.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Jins/Jins-MMF-14A-U456_0_1.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Jins/Jins-MMF-14A-U456_0_2.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Jins/Jins-MMF-14A-U456_0_3.png',
        'https://media.facecake.com/dev/cake-framework/testassets/glasses/Jins/Jins-MMF-14A-U456_0_4.png',
      ],
    }),
  },
];

export default glasses;